import React from 'react';
import { Box, Card, CardContent, Skeleton, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface KpiCardProps {
	label: string;
	value: string | number | null;
	subtitle?: string;
	loading?: boolean;
	prefix?: string;
	suffix?: string;
	tooltip?: string;
}

export function KpiCard({
	label,
	value,
	subtitle,
	loading = false,
	prefix = '',
	suffix = '',
	tooltip,
}: KpiCardProps): JSX.Element {
	return (
		<Card variant="outlined" sx={{ height: '100%' }}>
			<CardContent>
				<Box display="inline-flex" alignItems="center" gap={0.5}>
					<Typography
						variant="caption"
						color="text.secondary"
						sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 0.5 }}
					>
						{label}
					</Typography>
					{tooltip && (
						<Tooltip title={tooltip} placement="top" arrow>
							<InfoOutlinedIcon sx={{ fontSize: 13, color: 'text.disabled', cursor: 'help', flexShrink: 0 }} />
						</Tooltip>
					)}
				</Box>
				<Box mt={0.5}>
					{loading ? (
						<Skeleton width="70%" height={36} />
					) : (
						<Typography variant="h5" fontWeight={700} color="primary">
							{value !== null && value !== undefined ? `${prefix}${value}${suffix}` : '—'}
						</Typography>
					)}
				</Box>
				{subtitle && (
					<Typography variant="caption" color="text.secondary">
						{subtitle}
					</Typography>
				)}
			</CardContent>
		</Card>
	);
}
